import React from 'react';
import { Switch } from 'react-router-dom';

import PrivateRoute from '../../../routes/PrivateRoute';
import { ROUTES } from '../../../constants';

import { ReceiptsList } from '../pages/ReceiptsList';

export const ReceiptsRoute: React.FC = () => (
  <Switch>
    <PrivateRoute path={ROUTES.receipts} exact component={ReceiptsList} />
  </Switch>
);
